import { Cmd } from 'redux-loop';
import { AdminApi, PaginatedAdminIssuerListList } from 'api';
import { makeAuthenticatedApi } from 'core/api';

export async function getIssuersEffect(getState: Cmd.GetState): Promise<PaginatedAdminIssuerListList> {
  const adminApi = makeAuthenticatedApi(AdminApi, getState);

  return await adminApi.adminIssuersList({ limit: 1 });
}
